import React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import { history } from '../redux/store';
import routes from './routesConfig';

function RouterSwitch({ user }): JSX.Element {
  const localUser = JSON.parse(localStorage.getItem('user') || '{}');
  const userType = user.majority_type ?? localUser.majority_type;

  const renderRoutes = routeArray => routeArray.map((route, index) => (
    <Route key={index} {...route} />
  ));

  return (
    <ConnectedRouter history={history}>
      <Switch>
        {renderRoutes(routes.unprotected)}
        {renderRoutes(routes.protected)}
        {userType && renderRoutes(routes.roleSpecific[userType] || [])}
        <Redirect to="/login" />
      </Switch>
    </ConnectedRouter>
  );
}

const mapStateToProps = state => ({ user: state.login.information });

export default connect(mapStateToProps)(RouterSwitch);
